import { createIcon } from '@chakra-ui/icons';

export const UserFrame = createIcon({
  displayName: 'UserFrame',
  viewBox: '0 0 13 14',
  path: [
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_916_24054)">
        <path
          d="M11.375 0.5H1.625C0.727188 0.5 0 1.22719 0 2.125V11.875C0 12.7728 0.727188 13.5 1.625 13.5H11.375C12.2728 13.5 13 12.7728 13 11.875V2.125C13 1.22719 12.2728 0.5 11.375 0.5ZM3.25 11.0625C3.25 10.9 3.575 10.575 4.0625 10.3313L4.95625 9.84375C5.44375 10.0875 5.93125 10.25 6.5 10.25C7.06875 10.25 7.55625 10.0875 8.04375 9.84375L8.9375 10.3313C9.425 10.575 9.75 10.9 9.75 11.0625V11.875H3.25V11.0625ZM8.125 7C8.125 7.89375 7.39375 8.625 6.5 8.625C5.60625 8.625 4.875 7.89375 4.875 7V6.1875C4.875 5.29375 5.60625 4.5625 6.5 4.5625C7.39375 4.5625 8.125 5.29375 8.125 6.1875V7ZM11.375 11.0625C11.375 10.0063 10.2375 9.19375 9.75 8.95L9.2625 8.70625C9.5875 8.21875 9.75 7.65 9.75 7V6.1875C9.75 4.4 8.2875 2.9375 6.5 2.9375C4.7125 2.9375 3.25 4.4 3.25 6.1875V7C3.25 7.65 3.4125 8.21875 3.7375 8.70625L3.25 8.95C2.7625 9.19375 1.625 10.0063 1.625 11.0625V2.125H11.375V11.0625Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_916_24054">
          <rect width="13" height="13" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
